import { get, post } from '@/fn/ajax'
import { ListType } from '@/util/types'
import { Filter, FilterTree } from './types'
import {walkTree} from '@/fn/tree'

const gradeList1 = [
  {
    label: '全部',
    key: 'grade',
    value: 0,
  },
  {
    label: '一年级',
    key: 'grade',
    value: 10,
  },
  {
    label: '二年级',
    key: 'grade',
    value: 20,
  },
]

const gradeList2 = [
  {
    label: '全部',
    key: 'grade',
    value: 0,
  },
  {
    label: '七年级',
    key: 'grade',
    value: 60,
  },
  {
    label: '八年级',
    key: 'grade',
    value: 30,
  },
]

const subjectList1 = [
  {
    label: '全部',
    key: 'subject',
    value: 0,
  },
  {
    label: '语文',
    value: 100,
    key: 'subject',
    children: gradeList1
  },
  {
    label: '数学',
    value: 101,
    key: 'subject',
    children: gradeList1
  },
]

const subjectList2 = [
  {
    label: '全部',
    key: 'subject',
    value: 0,
  },
  {
    label: '英语',
    value: 500,
    key: 'subject',
    children: gradeList2
  },
  {
    label: '数学',
    value: 501,
    key: 'subject',
    children: gradeList2
  },
]

const phaseList = [
  {
    label: '所有学段',
    key: 'phase',
    value: 0,
  },
  {
    label: '小学',
    key: 'phase',
    value: 1,
    children: subjectList1
  },
  {
    label: '初中',
    key: 'phase',
    value: 2,
    children: subjectList2
  },
]

const phaseData = {
  label: '学段',
  key: 'type',
  value: 1,
  children: phaseList
}

const ageData = {
  label: '年龄',
  key: 'type',
  value: 2,
  children: [
    {
      label: '所有年龄',
      key: 'age',
      value: 0,
    },
    {
      label: '3~6岁',
      key: 'age',
      value: 1,
    },
    {
      label: '7~12岁',
      key: 'age',
      value: 2,
    },
  ]
}

const dateList = [
  {
    label: '所有课程',
    key: 'date',
    value: 0,
  },
  {
    label: '最近一周',
    key: 'date',
    value: 1,
  },
  {
    label: '最近一月',
    key: 'date',
    value: 2,
  },
]

const filterTree: Filter[] = [
  {
    label: '云端课程',
    key: 'filter',
    value: ListType.cloudCourse,
    children: [
      {
        label: '全部',
        key: 'type',
        value: 0,
      },

      phaseData,

      ageData,
    ]
  },

  {
    label: '我的课程',
    key: 'filter',
    value: ListType.myCourse,
    children: dateList
  },

  {
    label: '云端资源',
    key: 'filter',
    value: ListType.cloudResource,
    children: [
      {
        label: '全部类型',
        key: 'type',
        value: 0,
      },

      {
        label: 'VR课件',
        key: 'type',
        value: 1,
        children: [
          phaseData
        ]
      },

      {
        label: '3D模型',
        key: 'type',
        value: 2,
        children: [
          phaseData
        ]
      },

      {
        label: '全景图片',
        key: 'type',
        value: 3,
        children: [
          phaseData
        ]
      },
    ]
  },

  {
    label: '我的资源',
    key: 'filter',
    value: ListType.myResource,
    children: dateList
  },
]
let cache: any = null
export function getAllCate() {
  let changeschool = false
  try {
    changeschool = localStorage.getItem('changeschool') === 'true'
  } catch (e) {
    //
  }
  if (changeschool) {
    localStorage.setItem('changeschool', 'false')
    cache = null
  }
  if (!cache) {
    cache = get('/api/cate/newAll')
      .then(res => {
        const { data } = res
        if ( !data || !data.length) {
          return []
        }
        return walkTree(data, {
          childrenKey: 'subCate',
          onEachAfter(node) {
            const { id, name, key, subCate } = node
            return {
              value: id,
              label: name,
              key,
              children: subCate
            }
          }
        })
      })
    // cache = Promise.resolve(filterTree)
  }
  return cache
}

// const serverListType = {
//   10: 1,
//   11: 2,
//   20: 3,
//   21: 4
// }

export async function getTree(type: ListType, vm?: any ) {
  const _filterTree = await getAllCate()
  // const serverType = serverListType[type]
  const treeOptions = _filterTree.find((it: any) => it.value == type)
  if (!treeOptions) {
    return null
  }
  const tree = new FilterTree(treeOptions, {})
  return tree as FilterTree
}
